import styled from '@emotion/styled';
import { css } from 'theme-ui';

const ImageFIReport = styled.img(
  css({
    height: 'auto',
    width: ['80%', '50%'],
  }),
);

export default ImageFIReport;
